import { gql } from 'graphql.macro';

export const createReleaseNoteTemplate = gql`
    mutation createReleaseNote($releaseNote: CreateReleaseNoteInput!) {
        createReleaseNote(releaseNote: $releaseNote) {
            _id
            version
            organizationType
            isPublished
            translations {
                language
                content
            }
            createdAt
        }
    }
`;

export const translateReleaseNoteTemplate = gql`
    mutation translateReleaseNote($content: String!, $targetLanguage: String!) {
        translateReleaseNote(content: $content, targetLanguage: $targetLanguage)
    }
`;

export const updateReleaseNoteTemplate = gql`
    mutation updateReleaseNote($id: MongoDbObjectId!, $releaseNote: UpdateReleaseNoteInput!) {
        updateReleaseNote(id: $id, releaseNote: $releaseNote) {
            _id
            version
            organizationType
            isPublished
            translations {
                language
                content
            }
            createdAt
        }
    }
`;
